import { memo } from 'react';
import cn from 'classnames';
import { TPlansDetails } from 'src/types/plans.types';
import PlanCard from './PlanCard';
import styles from './carousel.module.scss';

type PricingCarouselProps = {
  plansInfo: TPlansDetails;
  addToCart: BaseAnyFunction;
  billingCycle: string;
};
const PricingCarousel = ({ plansInfo, addToCart, billingCycle }: PricingCarouselProps) => {
  if (!Object.keys(plansInfo).length) return null;
  const { smartHome, secondary } = plansInfo;

  return (
    <div className={cn('paddingY-medium1', styles.carouselContainer)}>
      <PlanCard addToCart={addToCart} billingCycle={billingCycle} planInfo={smartHome} />
      <PlanCard addToCart={addToCart} billingCycle={billingCycle} planInfo={secondary} />
    </div>
  );
};

export default memo(PricingCarousel);
